/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleDetails
 */
export interface RuleDetails {
    /**
     * 
     * @type {number}
     * @memberof RuleDetails
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RuleDetails
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof RuleDetails
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof RuleDetails
     */
    enabled: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleDetails
     */
    audience_ids: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof RuleDetails
     */
    traffic_allocation: number;
    /**
     * 
     * @type {number}
     * @memberof RuleDetails
     */
    days_running?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RuleDetails
     */
    primary_metric?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RuleDetails
     */
    layer_experiment_id?: number | null;
    /**
     * Type of rule distribution. Only a/b experiment can show distribution_mode field in the response
     * @type {string}
     * @memberof RuleDetails
     */
    distribution_mode?: RuleDetailsDistributionModeEnum;
    /**
     * A url to be used to find a particular Results page. This field is optional and returned only if rule has results
     * @type {string}
     * @memberof RuleDetails
     */
    readonly fetch_results_ui_url?: string;
    /**
     * A list of variation names
     * @type {Array<string>}
     * @memberof RuleDetails
     */
    variation_names: Array<string>;
    /**
     * Status of the rule
     * @type {string}
     * @memberof RuleDetails
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleDetails
     */
    readonly created_by_user_email?: string;
    /**
     * Timestamp when the Rule is created
     * @type {Date}
     * @memberof RuleDetails
     */
    readonly created_time?: Date | null;
    /**
     * Timestamp when the Rule is updated
     * @type {Date}
     * @memberof RuleDetails
     */
    readonly updated_time?: Date | null;
}

export function RuleDetailsFromJSON(json: any): RuleDetails {
    return RuleDetailsFromJSONTyped(json, false);
}

export function RuleDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'key': json['key'],
        'type': json['type'],
        'enabled': json['enabled'],
        'audience_ids': json['audience_ids'],
        'traffic_allocation': json['traffic_allocation'],
        'days_running': !exists(json, 'days_running') ? undefined : json['days_running'],
        'primary_metric': !exists(json, 'primary_metric') ? undefined : json['primary_metric'],
        'layer_experiment_id': !exists(json, 'layer_experiment_id') ? undefined : json['layer_experiment_id'],
        'distribution_mode': !exists(json, 'distribution_mode') ? undefined : json['distribution_mode'],
        'fetch_results_ui_url': !exists(json, 'fetch_results_ui_url') ? undefined : json['fetch_results_ui_url'],
        'variation_names': json['variation_names'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'created_by_user_email': !exists(json, 'created_by_user_email') ? undefined : json['created_by_user_email'],
        'created_time': !exists(json, 'created_time') ? undefined : (json['created_time'] === null ? null : new Date(json['created_time'])),
        'updated_time': !exists(json, 'updated_time') ? undefined : (json['updated_time'] === null ? null : new Date(json['updated_time'])),
    };
}

export function RuleDetailsToJSON(value?: RuleDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'key': value.key,
        'type': value.type,
        'enabled': value.enabled,
        'audience_ids': value.audience_ids,
        'traffic_allocation': value.traffic_allocation,
        'days_running': value.days_running,
        'primary_metric': value.primary_metric,
        'layer_experiment_id': value.layer_experiment_id,
        'distribution_mode': value.distribution_mode,
        'variation_names': value.variation_names,
        'status': value.status,
    };
}

/**
* @export
* @enum {string}
*/
export enum RuleDetailsDistributionModeEnum {
    Manual = 'manual',
    StatsAccelerator = 'stats_accelerator'
}


